import { render } from "./PdfFileInput.vue?vue&type=template&id=1ecbb5b9&scoped=true"
import script from "./PdfFileInput.vue?vue&type=script&lang=js"
export * from "./PdfFileInput.vue?vue&type=script&lang=js"

import "./PdfFileInput.vue?vue&type=style&index=0&id=1ecbb5b9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecbb5b9"]])

export default __exports__